module.exports = __webpack_public_path__ + "static/img/banner2.6b4f367f.png";